import styled from "styled-components";
import { ButtonBase } from "@mui/material";

export const Navbutton = styled(ButtonBase)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.05em;
    justify-content: start;
    padding-bottom: 20px;
  }
`;
